/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    confirmValidationKeyButton: {
        innerHTML: "Confirm key"
    },
    confirmValidationKeyTitle: {
        innerText: "Verify authentification key"
    },
    keyInput: {
        placeholder: "key"
    },
    loginInput: {
        placeholder: "login"
    }
};